<div [class]="containerClasses(level())" class="mb-4 h-full flex flex-col">
  <div [class]="background(level())" class="text-center p-4 font-semibold text-xl rounded-t-sm">
    @for (star of stars(level()); track $index) {
      <app-icons icon="star"/>
    }
    {{ level() | uppercase }}
  </div>
  <div class="text-center flex flex-col flex-1">
    <div>
      <div class="p-4 inline-block">
        <app-item-image [item]="item()" width="100" height="100" (click)="showDetails.set(true)"
                        class="cursor-pointer"/>
      </div>

      <p><span class="font-bold">{{ price() | currency }}</span> ea.</p>
      <p class="font-semibold">{{ item().brand }}</p>
      <p [title]="item().model" class="line-clamp-1">{{ item().model }}</p>
      <p [title]="item().item_number" class="line-clamp-1">{{ item().item_number }}</p>
      <p>{{ item().size }} {{ getFeatureString(item()) }}</p>

      @if (item().features.mileage_warranty) {
        <div class="bg-gray-200 my-2">
          <div class="flex justify-between text-sm py-1 px-4">
            <span class="truncate min-w-0" title="Warranty">Warranty</span>
            <span class="font-semibold shrink-0">{{ item().features.mileage_warranty }}</span>
          </div>
        </div>
      } @else {
        <div class="py-4"></div>
      }

      @if (item().customer_notes; as notes) {
        <div class="text-left text-gray-500 dark:text-gray-400 px-4 pt-2 whitespace-pre-line">
          {{ notes }}
        </div>
      }
    </div>

    <div class="px-4 space-y-4 mt-auto">
      <app-accordion label="Details" [isOpen]="selectionStore.addonsOpen()" (isOpenChange)="selectionStore.setAddonsOpen($event)">
        <header class="text-sm">Details</header>

        <div class="text-sm space-y-2">
          <div class="font-semibold flex justify-between">
            <span>Subtotal</span>
            <span>{{ subtotal() | currency }}</span>
          </div>

          @if (maxAddonRows() > 0) {
            <app-hr></app-hr>
          }

          @for (addon of includedAddons(); track addon.item_id) {
            <div class="flex justify-between text-sm py-1">
              <span class="truncate min-w-0" [title]="addon.description">{{ addon.description }}</span>
              <span class="font-semibold shrink-0">{{ addon.price_each ? (addon.price_each | currency) + ' ea.' : '-' }}</span>
            </div>
          }
          @for (_ of addonPadRows(); track $index) {
            <div class="text-sm py-1">&nbsp;</div>
          }

          @if (maxFeeRows() > 0) {
            <app-hr/>
            @for (fee of fees(); track fee.fee_id) {
              <div class="flex justify-between text-sm py-1">
                <span class="truncate min-w-0" [title]="fee.description">{{ fee.description }}</span>
                <span class="font-semibold shrink-0">{{ fee.total ? (fee.total - fee.tax | currency) : '-' }}</span>
              </div>
            }
            @for (_ of feePadRows(); track $index) {
              <div class="text-sm py-1">&nbsp;</div>
            }
          }

          <div class="flex justify-between">
            <span>Sales Tax</span>
            <span class="font-semibold shrink-0">{{ taxAfterAddons() | currency }}</span>
          </div>

          <app-hr></app-hr>
        </div>
      </app-accordion>

      <div class="flex justify-between text-md text-brand font-semibold">
        <span>Total</span>
        <span>{{ totalAfterAddons() | currency }}</span>
      </div>

      <div class="mb-2">
        <app-button variant="secondary" size="small" (click)="selectItem()" [disabled]="disabled()">
          @if (isSelected()) {
            Selected
          } @else {
            Select <app-icons icon="arrow-right"></app-icons>
          }
        </app-button>
      </div>
    </div>
  </div>
</div>

<app-results-item-details-modal [item]="item()" [(isOpen)]="showDetails"/>
